module.exports = __webpack_public_path__ + "static/speedclock-c9ab0822a3254c7881981757d4b87e61.svg";